<template>
  <section class="user-info" v-if="ready">
    <div v-if="picture" class="user-info__image" :style="{backgroundImage: 'url(' + picture + ')'}" />

    <div class="user-info__text">
      <p class="user-info__heading"><span>My Stoke</span> Account</p>
      <p class="user-info__name">{{ firstName }} {{ lastName }}</p>

      <div class="user-info__links">
        <button @click="logout()" class="user-info__link" type="button">Sign out</button>
        <a :href="helpURL" class="user-info__link">Help</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UserInfo',

  data () {
    return {
      ready: false,
      firstName: '',
      lastName: '',
      picture: '',
      helpURL: 'mailto:tickets@stokecityfc.com'
    }
  },

  mounted () {

    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {
      this.firstName = userData.given_name
      this.lastName = userData.family_name
      this.picture = userData.picture

      // tell the app that we've finished loading
      this.ready = true
    }, 
    (err)=> {
        console.log('Unable to load user profile, session may not be present.')
    });
  },
  methods: {
    logout () {
      console.log("logout called")
      this.$signOut();
      this.$router.push("/");
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-info {
    // stacked on mobile, where this card only gets half the header row
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    max-width: 260px;

    // on desktop it sits in the header's left column, which is far wider than
    // 260px — go back to a row and take enough of that room for the heading to
    // fit on one line, but no more, so the card stays pinned to the page edge
    // and the slack in the column becomes breathing room around the crest
    @media screen and (min-width: 700px) {
      flex-direction: row;
      align-items: center;
      max-width: 340px;
    }

    &__image {
      flex: 0 0 auto;
      margin: 0 0 8px;
      height: 64px;
      width: 64px;
      background-size: cover;
      border-radius: 50%;

      @media screen and (min-width: 700px) {
        margin: 0 15px 0 0;
        height: 80px;
        width: 80px;
      }
    }

    &__text {
      min-width: 0;
      width: 100%;
    }

    &__heading {
      margin: 0;
      padding: 0 0 5px;
      color: #D7172F;
      font-size: 16px;
      font-weight: 300;

      @media screen and (min-width: 700px) {
        font-size: 20px;
      }

      // guaranteed single line once there is comfortably room for it, whatever
      // the font metrics turn out to be
      @media screen and (min-width: 960px) {
        white-space: nowrap;
      }

      span {
        font-weight: 500;
      }
    }

    &__name {
      margin: 0;
      padding: 0 0 7px;
      font-size: 15px;
      overflow-wrap: break-word;

      @media screen and (min-width: 700px) {
        font-size: 18px;
      }
    }

    &__links {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    // the button and the anchor have to render identically — the global reset
    // leaves <button> with its native border/background
    &__link {
      appearance: none;
      background: none;
      border: 0;
      padding: 0;
      margin: 0 20px 0 0;
      color: #D7172F;
      font-family: inherit;
      font-size: 12px;
      line-height: 1.7;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
